import { createBrowserRouter } from 'react-router-dom'
import GeneralError from './pages/errors/general-error'
import NotFoundError from './pages/errors/not-found-error'
import MaintenanceError from './pages/errors/maintenance-error'
import UnauthorisedError from './pages/errors/unauthorised-error.tsx'
import ForbiddenError from './pages/errors/forbidden-error.tsx'
import childRoutes from './routes/index.tsx'
import ProtectedRoute from './components/protected-route.tsx'
import { RouteConfig } from './types/utility.types.ts'
import AppShell from './components/layout/app-shell.tsx'

const authRoutes = [
  { path: '/sign-in', lazy: () => import('./pages/auth/sign-in-2') },
  { path: '/sign-up', lazy: () => import('./pages/auth/sign-up') },
  {
    path: '/forgot-password',
    lazy: () => import('./pages/auth/forgot-password'),
  },
]

const errorRoutes = [
  { path: '/500', Component: GeneralError },
  { path: '/404', Component: NotFoundError },
  { path: '/503', Component: MaintenanceError },
  { path: '/401', Component: UnauthorisedError },
  { path: '/403', Component: ForbiddenError },
]

const convertRouteConfig = (routes: RouteConfig[]) => {
  return routes.map((route) => ({
    path: route?.path,
    async lazy() {
      const { Component } = await route.lazy()
      return { Component }
    },
  }))
}

const router = createBrowserRouter(
  [
    // Auth routes (public)
    ...authRoutes.map(({ path, lazy }) => ({
      path,
      async lazy() {
        const Component = (await lazy()).default
        return { Component }
      },
    })),

    // Protected routes
    {
      path: '/',
      element: <ProtectedRoute />, // Wrap protected routes
      children: [
        {
          path: '/',
          element: <AppShell />,
          // Active in every built app (prod + staging) where hashed chunks can go
          // stale after a deploy; left off in `pnpm dev` (no chunk removal there,
          // and raw router errors are more useful for local debugging).
          errorElement: import.meta.env.DEV ? null : <GeneralError />,
          children: convertRouteConfig(childRoutes), // Protected children routes
        },
      ],
    },

    // Error routes
    ...errorRoutes,

    // Fallback 404 route
    { path: '*', Component: NotFoundError },
  ],
  {
    basename: '/',
  }
)

export default router
